import { convertKeyValueToFormDataV2 } from '~/helpers/helpers';
import { emperor } from '~/services';
import { GatheringTemplate } from '~/types/gathering';

export type GlobalEventTemplateDTO = {
  title: string;
  description: string;
  whatToBring: string | null;
  image?: File | string;
  howToUrl: string | null;
  recommendedMonth: string | null;
};

export const getGlobalEventTemplates = async (): Promise<
  GatheringTemplate[]
> => {
  const res = await emperor.get('gathering-template/master');
  return res.data;
};

export const createGlobalEventTemplate = async (
  templateData: GlobalEventTemplateDTO
): Promise<GatheringTemplate> => {
  return await emperor.post(
    'gathering-template/master',
    convertKeyValueToFormDataV2(templateData)
  );
};

export const updateGlobalEventTemplate = async ({
  templateId,
  templateData
}: {
  templateId: string;
  templateData: GlobalEventTemplateDTO;
}): Promise<GatheringTemplate> => {
  return await emperor.patch(
    `gathering-template/master/${templateId}`,
    convertKeyValueToFormDataV2(templateData)
  );
};

export const deleteGlobalEventTemplate = async (
  templateId: string
): Promise<void> => {
  return await emperor.delete(`gathering-template/master/${templateId}`);
};
